// extracted by mini-css-extract-plugin
module.exports = {"search":"search__3C8hI","icon":"icon__3klL7"};